/** @format */
import { TFunction } from 'i18next';
import { ref, string } from 'yup';

/**
 * In latest versions of Yup, email validation was updated to follow the
 * RFC 5322 standard which is more permissive than the previous version.
 */
export const legacyEmailRegex = // eslint-disable-next-line no-control-regex
    /^((([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

export const email = (t: TFunction) =>
    string()
        .required(t('Please enter an email address'))
        .max(254, t('Email address cannot be longer than 254 characters'))
        .matches(
            legacyEmailRegex,
            t(
                "Something's not quite right with this email address. Please double-check it's not a typo."
            )
        );

export const firstName = (t: TFunction) =>
    string().required(t('Please enter a first name'));

export const lastName = (t: TFunction) =>
    string().required(t('Please enter a last name'));

export const phone = (t: TFunction) =>
    string().required(t('Please enter a phone number'));

export const password = (t: TFunction) =>
    string()
        .required(t('Please enter a password'))
        .min(8, t('Your password needs to be at least 8 characters.'));

export const confirmPassword = (t: TFunction, refPath: string = 'password') =>
    string()
        .required(t('Please confirm password'))
        .oneOf(
            [ref(refPath)],
            t('Oops, passwords must match. Please try again.')
        );
